var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.isVisible,
        title: _vm.title,
        "destroy-on-close": true,
      },
      on: { close: _vm.hide },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: !_vm.isInitialized,
              expression: "!isInitialized",
            },
          ],
          staticClass: "wrapper",
          attrs: { "element-loading-spinner": "el-icon-loading" },
        },
        [_c("note-list-table", { attrs: { items: _vm.items } })],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }